import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type ProductSliderSourceContextValue = {
    products: Array<Product<ProductFieldSet.ProductTile>>;
};

type ProductSliderSourceContextProviderProps = {
    products: Array<Product<ProductFieldSet.ProductTile>>;
    children: ReactNode;
};

export const ProductSliderSourceContext = createContext<
    ProductSliderSourceContextValue | undefined
>(undefined);
ProductSliderSourceContext.displayName = "ProductSliderSourceContext";

export const ProductSliderSourceContextProvider = ({
    products,
    children
}: ProductSliderSourceContextProviderProps) => {
    return (
        <ProductSliderSourceContext
            value={{
                products: products
            }}
        >
            {children}
        </ProductSliderSourceContext>
    );
};

export const useProductSliderSourceContext = () => {
    const context = use<ProductSliderSourceContextValue | undefined>(
        ProductSliderSourceContext
    );

    if (!isDefined(context)) {
        throw new Error(
            `${ProductSliderSourceContext.displayName} is undefined.`
        );
    }

    return context;
};
